export default __webpack_public_path__ + "static/media/openFace3.06cda9c9.png";